<template>
  <div>
    <div class="text-xs-right red-text">
      <span class="red--text">{{ cautionMessage }}</span>
    </div>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      hide-actions
      style="width:100%;"
    >
      <template v-slot:items="props" style="width:100%;">
        <tr>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">
            <AppUnitType :value="props.item.unitType" />
            <AppUnitTypeToolTip :unitType="props.item.unitType" />
          </td>
          <td class="text-xs-right">
            <AppCurrency
              :value="props.item.grossPrice"
              currency="JPY"
              actual-number
            />
          </td>
        </tr>
        <tr>
          <td ss="text-xs-left" colspan="5">
            <span class="description">{{ props.item.description }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'FormMenuConfirm',
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    menuId: {
      type: Number,
      default: 0,
    },
    menuList: {
      type: Array,
      default: () => {},
    },
    cautionMessage: {
      type: String,
      default: '',
    },
    loading: Boolean,
  },
  computed: {
    menu() {
      if (this.menuList) {
        return this.menuList.find(m => m.id === this.menuId)
      }
      return null
    },
    items() {
      return this.menu ? [this.menu] : []
    },
    headers() {
      return [
        { text: 'メニュー名', sortable: false },
        {
          text: '課金形態',
          sortable: false,
        },
        {
          text: '配信単価',
          sortable: false,
        },
      ]
    },
  },
}
</script>

<style scoped>
.description {
  opacity: 0.5;
}
</style>
